<!--Dialog para visualizar mapa-->
<p-dialog
    [header]="'Mapa'"
    [modal]="true" (onHide)="closeLeaflet()"
    [(visible)]="dialogLeafletView"
    [style]="{ width: '90%', height: '80%' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [maximizable]="true">
    <ng-template pTemplate="content">
        <shared-loader [hidden]="geoMapService.datosCargado()"></shared-loader>
        <div *ngIf="geoMapService.datosCargado()" style="height: 95vh; width: 100vw;" leaflet
             [leafletOptions]="options" (leafletMapReady)="onMapReady($event)" (leafletClick)="onClicMapMarker($event)"></div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cerrar" class="p-button-text"
                (click)="closeLeaflet()"></button>
    </ng-template>
</p-dialog>

